import React from 'react';
import './Preloader.css';

const Preloader = () => (
  <div className="Preloader">
    <div className="Preloader__container">
      <span className="Preloader__round"></span>
    </div>
  </div>
);

export default Preloader;
